import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

export interface CustomToggleProps {
  id?: string;
  labelA?: string;
  labelB?: string;
  defaultToggled?: boolean;
  toggled?: boolean;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onToggle?: (
    value: boolean,
    htmlFor: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  name?: string;
  disabled?: boolean;
}

const CustomToggle: React.FC<CustomToggleProps> = ({
  id,
  labelA = 'Off',
  labelB = 'On',
  defaultToggled = false,
  toggled,
  className,
  onChange,
  onToggle,
  name,
  disabled = false,
  ...other
}) => {
  const [isToggled, setIsToggled] = useState(toggled ?? defaultToggled);

  useEffect(() => {
    if (typeof toggled !== 'undefined') {
      setIsToggled(toggled);
    }
  }, [toggled]);

  const htmlFor =
    id || name || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  const wrapperClasses = classNames(
    'wfp--form-item',
    'custom-toggle-wrapper',
    className,
  );

  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;

    if (typeof toggled === 'undefined') {
      setIsToggled(newValue);
    }

    if (onChange) {
      onChange(event);
    }

    if (onToggle) {
      onToggle(newValue, htmlFor, event);
    }
  };

  return (
    <div className={wrapperClasses}>
      <input
        {...other}
        type="checkbox"
        id={htmlFor}
        name={name}
        className="wfp--toggle custom-toggle"
        checked={isToggled}
        onChange={handleToggleChange}
        disabled={disabled}
      />
      <label
        className="wfp--toggle__label custom-toggle__label"
        htmlFor={htmlFor}
      >
        <span className="wfp--toggle__text--left custom-toggle__text--left">
          {labelA}
        </span>
        <span className="wfp--toggle__appearance custom-toggle__appearance" />
        <span className="wfp--toggle__text--right custom-toggle__text--right">
          {labelB}
        </span>
      </label>
    </div>
  );
};

CustomToggle.displayName = 'CustomToggle';

export default CustomToggle;
